import React from 'react'
import ReportCalendarFilters from './Filters/ReportCalendarFilters'
import ReportCalendarReportingTimeline from './ReportingTimeline/ReportCalendarReportingTimeline'
import ReportCalendarUpcomingReports from './UpcomingReports/ReportCalendarUpcomingReports'
import '../styles/report-calendar-right-part.sass'

const RightPart = ({
	timelineDates,
	timelineSourceDates,
	timelineCompanies,
	upcomingReportsGroups,
	canGoToPreviousTimelineDate,
	canGoToNextTimelineDate,
	isTimelineLoading,
	isUpcomingLoading,
	filterValues,
	filterOptions,
	onFilterChange,
	onPreviousTimelineDate,
	onNextTimelineDate,
	onCreate,
	onReportSelect,
}) => {
	return (
		<div className='reporting-calendar-right-part'>
			<div className='reporting-calendar-right-part__toolbar'>
				<ReportCalendarFilters
					values={filterValues}
					options={filterOptions}
					onChange={onFilterChange}
				/>

				<button
					type='button'
					className='reporting-calendar-right-part__create-btn'
					onClick={onCreate}
				>
					+ Create
				</button>
			</div>

			<ReportCalendarReportingTimeline
				dates={timelineDates}
				sourceDates={timelineSourceDates}
				companies={timelineCompanies}
				canGoPrevious={canGoToPreviousTimelineDate}
				canGoNext={canGoToNextTimelineDate}
				isLoading={isTimelineLoading}
				onPrevious={onPreviousTimelineDate}
				onNext={onNextTimelineDate}
				onReportSelect={onReportSelect}
			/>

			<ReportCalendarUpcomingReports
				groups={upcomingReportsGroups}
				isLoading={isUpcomingLoading}
				onCreate={onCreate}
				onReportSelect={onReportSelect}
			/>
		</div>
	)
}

export default RightPart
